/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Claims_SubmitInputs */

const en_claims_submit = /** @type {(inputs: Claims_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Submit Claim`)
};

const fr_claims_submit = /** @type {(inputs: Claims_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Soumettre la réclamation`)
};

/**
* | output |
* | --- |
* | "Submit Claim" |
*
* @param {Claims_SubmitInputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const claims_submit = /** @type {((inputs?: Claims_SubmitInputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Claims_SubmitInputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_claims_submit(inputs)
	return fr_claims_submit(inputs)
});